export default __webpack_public_path__ + "static/banner_login-50f0f85b0d5a7afeeb0b794fc37bd2f5.png";